module.exports = __webpack_public_path__ + "img/io.419c8cbc.png";